import { render, staticRenderFns } from "./ProFeatureTable.vue?vue&type=template&id=4bbd5690&scoped=true&"
import script from "./ProFeatureTable.vue?vue&type=script&lang=js&"
export * from "./ProFeatureTable.vue?vue&type=script&lang=js&"
import style0 from "./ProFeatureTable.vue?vue&type=style&index=0&id=4bbd5690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd5690",
  null
  
)

export default component.exports